module.exports = __webpack_public_path__ + "static/2-04008d165b4984c51c1f3663aac148da.jpeg";